<template>
  <div v-if="options" class="chart-wrap">
    <highcharts :options="options"/>
  </div>
</template>

<script>
import { Chart } from 'highcharts-vue';

const TYPE_MAP = { bar: 'column', line: 'line', pie: 'pie' };
const PALETTE = ['#4f6df5', '#00a3a3', '#f0a202', '#e0567a', '#7c5cff', '#2fa84f', '#e2703a', '#3aa0d9'];

function toNumber(value) {
  if (value === null || value === undefined || value === '') return 0;
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
}

export default {
  name: 'ChartFromAi',
  components: { highcharts: Chart },
  props: {
    chart: { type: Object, required: true },
  },
  computed: {
    rows() {
      const c = this.chart;
      return c && Array.isArray(c.rows) ? c.rows : [];
    },
    options() {
      const c = this.chart;
      // rows может прийти пустым — тогда график не рисуем
      if (!c || !this.rows.length || !c.x_field || !c.y_field) return null;

      const hcType = TYPE_MAP[c.type] || 'column';
      const title = c.title || '';
      const seriesName = title || c.y_field;
      const base = {
        credits: { enabled: false },
        title: { text: title, style: { fontSize: '14px', fontWeight: '600' } },
        colors: PALETTE,
        chart: { type: hcType, height: 320, style: { fontFamily: 'inherit' } },
      };

      if (hcType === 'pie') {
        return {
          ...base,
          tooltip: { pointFormat: '<b>{point.y}</b> ({point.percentage:.1f}%)' },
          plotOptions: {
            pie: {
              dataLabels: { enabled: true, format: '{point.name}: {point.percentage:.1f}%' },
            },
          },
          series: [{
            name: seriesName,
            colorByPoint: true,
            data: this.rows.map(r => ({
              name: String(r[c.x_field] ?? ''),
              y: toNumber(r[c.y_field]),
            })),
          }],
        };
      }

      const categories = this.rows.map(r => String(r[c.x_field] ?? ''));
      return {
        ...base,
        xAxis: {
          categories,
          title: { text: c.x_field },
          // при большом количестве точек подписи не помещаются горизонтально
          labels: categories.length > 8 ? { rotation: -45, style: { fontSize: '11px' } } : {},
        },
        yAxis: { title: { text: c.y_field } },
        legend: { enabled: false },
        tooltip: { headerFormat: '<b>{point.key}</b><br/>', pointFormat: `${c.y_field}: <b>{point.y}</b>` },
        series: [{
          name: seriesName,
          data: this.rows.map(r => toNumber(r[c.y_field])),
        }],
      };
    },
  },
};
</script>

<style scoped lang="scss">
.chart-wrap {
  margin: .75rem 0;
  background: #fff;
  border: 1px solid var(--ai-border);
  border-radius: 10px;
  padding: .5rem;
}
</style>
